import type { UIFlagFilter } from '../types';

/**
 * UI-specific default flag filter values
 */
export const defaultFlagFilter: UIFlagFilter = {
  state: 'live',
};
